export default __webpack_public_path__ + "static/article-the-top-tv-shows-of-the-last-year-ea1c4766473d7e2780d4ef27b0f14b10.jpg";